<div class="grid-container">
<div class="content-header">Reset Password</div>

<div class="content-with-elevation content">
    <change-password [changingExpiredPassword]="true" (passwordChanged)="passwordChanged($event)"></change-password>
</div>
</div>
